import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { initialVacancyState, vacancyReducer } from 'src/scenes/vacancy/reducer';
import {
    initialState as initialAdministratorState,
    reducer as administratorReducer,
} from '../scenes/administrator/reducer';
import { initialState as initialCandidateState, reducer as candidateReducer } from '../scenes/candidate/reducer';
import {
    initialState as initialHiringManagerState,
    reducer as hiringManagerReducer,
} from '../scenes/hiring-manager/reducer';
import { AppState } from '../types/store';

export default combineReducers({
    router: routerReducer,
    administrator: administratorReducer,
    candidate: candidateReducer,
    hiringManager: hiringManagerReducer,
    vacancy: vacancyReducer,
});

export const emptyAppState = (): AppState => {
    const state: AppState = {
        candidate: initialCandidateState,
        administrator: initialAdministratorState,
        hiringManager: initialHiringManagerState,
        vacancy: initialVacancyState,
    };
    return state;
};



// WEBPACK FOOTER //
// ./src/store/reducer.ts